import React, { FC } from 'react'

type AuthenticatedRouteProps = {
  onlyPublic?: boolean
  children?: React.ReactNode
}

export const AuthenticatedRoute: FC<AuthenticatedRouteProps> = () => {
  // Do we even need this anymore?

  return <></>
}
